export default __webpack_public_path__ + "static/media/GoogleCloud.a9e35d53.png";